import { FC } from "react";

interface ITrackingPointTooltipContentProps {
  /** Pre-formatted point time (e.g. "08:42"). */
  time: string;
  /** Pre-formatted speed (e.g. "48 km/h") or the no-value placeholder. */
  speed: string;
  /** Pre-translated note shown when the point sits after a GPS signal gap (approximate path). Omitted otherwise. */
  gapNote?: string;
}

/** Hover-tooltip body for a tracking trail point: time on top, speed below, optional GPS-gap note. */
export const TrackingPointTooltipContent: FC<
  ITrackingPointTooltipContentProps
> = ({ time, speed, gapNote }) => (
  <div className="custom-tracking-tooltip__content">
    <span className="custom-tracking-tooltip__time">{time}</span>
    <span className="custom-tracking-tooltip__speed">{speed}</span>
    {gapNote ? (
      <span className="custom-tracking-tooltip__gap">{gapNote}</span>
    ) : null}
  </div>
);
